import { render, staticRenderFns } from "./Live_news.vue?vue&type=template&id=065dde6d"
import script from "./Live_news.vue?vue&type=script&lang=js"
export * from "./Live_news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports